import search from './components/_search.js'
import burgerNav from './components/_burgerNav.js'
import slideshow from './components/_slideshow.js'
import filterNav from './components/_filterNav.js'
import expandable from './components/_expandable.js'
import equalizeHeights from './components/_equalizeHeights.js'
import lightbox from './components/_lightbox.js'
import thumbStrip from './components/_thumbStrip.js'
import podcast from './components/_podcast.js'
import entrance from './components/_entrance.js'
import hoverTile from './components/_hoverTile.js'
import CustomSelect from './components/_customSelect.js'

const entranceElements = document.querySelectorAll('[data-transition]')
if( entranceElements ) {
    Array.from(entranceElements).forEach( element => {
        entrance(element)
    })
}

const customSelects = document.querySelectorAll('[data-custom-select]')
if( customSelects ) {
    Array.from(customSelects).forEach( element => {
        new CustomSelect(element)
    })
}

const hoverTiles = document.querySelectorAll('.hover-tile');
if( hoverTiles ) {
    Array.from(hoverTiles).forEach( element => {
        hoverTile(element)
    })
}

search.init()
burgerNav.init()
slideshow.init()
filterNav.init()
expandable.init()
equalizeHeights.init()
lightbox.init()
thumbStrip.init()
podcast.init()
